import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';

const CelebrationHeader = ({ planName }) => {
  return (
    <div className="bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 text-white py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Animated Success Icon */}
        <div className="inline-flex items-center justify-center mb-6 relative">
          <div className="absolute inset-0 animate-ping opacity-75">
            <CheckCircle2 size={80} className="text-white" />
          </div>
          <CheckCircle2 size={80} className="text-white relative z-10" />
        </div>

        {/* Congratulatory Message */}
        <h1 className="text-4xl md:text-5xl font-bold mb-4 flex items-center justify-center gap-3">
          <Sparkles className="w-8 h-8 animate-pulse" />
          Welcome to Premium!
          <Sparkles className="w-8 h-8 animate-pulse" />
        </h1>
        <p className="text-xl md:text-2xl mb-2 font-semibold">
          Your {planName} subscription is now active
        </p>
        <p className="text-lg opacity-90">
          You now have access to all Premium features and benefits
        </p>
      </div>
    </div>
  );
};

export default CelebrationHeader;